import { usePaneStore } from "../state/store-context";
import "./RevalidationOverlay.css";

export function RevalidationOverlay() {
  const isRevalidating = usePaneStore((s) => s.isRevalidating);
  if (!isRevalidating) return null;

  return (
    <div className="revalidation-overlay">
      <div className="revalidation-overlay__content">
        <div className="revalidation-overlay__spinner" />
        <span>Validating...</span>
      </div>
    </div>
  );
}
